/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyDollar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m13 1-.001 2H18v2h-5.001v6H14c2.757 0 5 2.243 5 5s-2.243 5-5 5h-1.001v2h-2v-2H6v-2h4.999v-6H10c-2.757 0-5-2.243-5-5s2.243-5 5-5h.999V1zm-.001 18H14c1.654 0 3-1.346 3-3s-1.346-3-3-3h-1.001zm-2-8V5H10C8.346 5 7 6.346 7 8s1.346 3 3 3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyDollar as CurrencyDollar };
